
window.addEventListener('DOMContentLoaded', function() {
	var flag = true;
    setInterval(imageSwitch, 2000);

  
    function imageSwitch() {
        if($(window).width() < 767){
            if(flag){
                $('product-card .has-hover-image img.card__hover-image').removeClass('hide-image').addClass('show-image');
                $('product-card .has-hover-image img.card__main-image').addClass('hide-image').removeClass('show-image');
                flag = false;
            }else{
                $('product-card .has-hover-image img.card__main-image').removeClass('hide-image').addClass('show-image');
                $('product-card .has-hover-image img.card__hover-image').addClass('hide-image').removeClass('show-image');
                flag = true;
            }
        }
    }
});
